import type { InvariantRoute } from '@atlassian/react-resource-router/src/common/types';

export const systemConfigurationRedirectRoute: InvariantRoute = {
	name: 'system-configuration-general-redirect',
	path: '/secure/admin/ViewApplicationProperties.jspa',
	exact: true,
};
